import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "route" }
const _hoisted_2 = { class: "flex flex-col items-left justify-between sm:flex-row sm:items-center" }
const _hoisted_3 = { class: "flex items-center justify-between sm:justify-start" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Alamat Pengiriman", -1)
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = {
  class: "border-right-grey-lighten-3 px-3",
  style: {"width":"80%"}
}
const _hoisted_7 = { class: "font-bold break-words" }
const _hoisted_8 = { class: "break-words color-blue-grey-darken-1 font-semibold" }
const _hoisted_9 = { class: "break-words color-blue-grey-darken-1 font-semibold" }
const _hoisted_10 = {
  class: "px-6 flex items-center justify-center",
  style: {"width":"20%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Card = _resolveComponent("Card")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_AlamatPerusahaanForm = _resolveComponent("AlamatPerusahaanForm")
  const _component_Sidebar = _resolveComponent("Sidebar")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            (_ctx.route.meta.permission.write)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Tambah Alamat",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectAdd())),
                  icon: "pi pi-plus",
                  class: "font-semibold p-button-sm btn-primary"
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", null, [
            _createVNode(_component_InputIconRightGrey, {
              modelValue: _ctx.inputSearch,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputSearch = $event)),
              placeholder: "Cari Disini ...",
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.searchData(_ctx.inputSearch)), ["enter"])),
              type: _ctx.$enumBase.input.text,
              icon: _ctx.$icon.svg.searchEva,
              class: "mt-3 sm:mt-0"
            }, null, 8, ["modelValue", "type", "icon"])
          ])
        ])
      ]),
      content: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataAddress, (item, index) => {
          return (_openBlock(), _createBlock(_component_Card, {
            class: "card-no-shadow card-item-category mb-4 hover:bg-gray-50",
            key: index
          }, {
            content: _withCtx(() => [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("h5", _hoisted_7, _toDisplayString(item.Alias) + " (" + _toDisplayString(item.Penerima) + ")", 1),
                  _createVNode("span", _hoisted_8, _toDisplayString(item.Kota.Nama) + " - " + _toDisplayString(item.Alamat), 1),
                  _createVNode("p", _hoisted_9, _toDisplayString(item.Telepon), 1)
                ]),
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_InputSwitch, {
                    disabled: !_ctx.route.meta.permission.update,
                    class: "switch-og",
                    modelValue: item.IsActive,
                    "onUpdate:modelValue": ($event: any) => (item.IsActive = $event),
                    onChange: ($event: any) => (_ctx.changeIsActive(item))
                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"]),
                  (_ctx.route.meta.permission.update || _ctx.route.meta.permission.delete)
                    ? (_openBlock(), _createBlock("i", {
                        key: 0,
                        class: "pi pi-ellipsis-h text-base cursor-pointer text-black ml-6",
                        onClick: ($event: any) => (_ctx.showDropDown($event, item))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Paginator, {
          rows: _ctx.filter.top,
          totalRecords: _ctx.filter.totalRecords,
          onPage: _ctx.onPage
        }, null, 8, ["rows", "totalRecords", "onPage"])
      ]),
      _: 1
    }),
    _createVNode(_component_Sidebar, {
      class: "type-bus-sidebar",
      visible: _ctx.sliderActive,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.sliderActive = $event)),
      showCloseIcon: false,
      position: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AlamatPerusahaanForm, {
          idCompany: _ctx.Id,
          data: _ctx.dataForm,
          onReloadData: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getDataAddress())),
          onCloseSidebar: _ctx.closeSidebar
        }, null, 8, ["idCompany", "data", "onCloseSidebar"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          del: _ctx.route.meta.permission.delete,
          edit: _ctx.route.meta.permission.update,
          onDel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteData(_ctx.dataForm.Id))),
          onEdit: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editData(_ctx.dataForm)))
        }, null, 8, ["del", "edit"])
      ]),
      _: 1
    }, 512)
  ]))
}